export default __webpack_public_path__ + "static/media/screen8.bd94a3eb.png";